import axios from 'axios';

export default class {
  constructor(options) {
    this.URL = `${options.baseUrl}/rauth`;
  }

  async login(email, password) {
    const res = await axios.post(
      `${this.URL}/login/`,
      {
        email: email,
        password: password,
      },
      { withCredentials: true },
    );

    return res.data;
  }

  async refresh() {
    const res = await axios.post(`${this.URL}/login/refresh/`, null, { withCredentials: true });

    return res.data;
  }

  async register(
    email,
    password,
    skipEmailVerification,
    personalExplanation,
    datasetType,
    organization,
    role,
    referral,
  ) {
    const res = await axios.post(`${this.URL}/register/`, {
      email: email,
      password: password,
      inviteId: skipEmailVerification,
      personalExplanation: personalExplanation,
      datasetType: datasetType,
      organization: organization,
      role: role,
      referral: referral,
    });

    return res.data;
  }

  async resendAccountVerificationLink(email) {
    const res = await axios.post(`${this.URL}/resend-verification-email`, {
      email: email,
    });

    return res.data;
  }

  async sendResetPasswordLink(email) {
    const res = await axios.post(`${this.URL}/send-reset-password-email`, {
      email: email,
    });

    return res.data;
  }

  async resetPassword(uidb64, token, password) {
    const res = await axios.post(`${this.URL}/reset-password`, {
      uidb64,
      token,
      password,
    });

    return res.data;
  }
}
